<script setup lang="ts">
import { computed, ref } from 'vue'

import { careerPaths } from '../../data/siteContent'

const activeId = ref(careerPaths[0]!.id)
const activePath = computed(() => careerPaths.find((path) => path.id === activeId.value)!)
</script>

<template>
  <section
    id="careers"
    class="section careers-section"
    :style="{ '--portal-color': activePath.color }"
    aria-labelledby="careers-title"
  >
    <div class="section-frame">
      <div class="section-heading section-heading--split" data-reveal>
        <div>
          <p class="section-kicker">03 / CHOOSE A SIGNAL</p>
          <h2 id="careers-title">职业传送门</h2>
        </div>
        <p>方向不是一道只能答一次的选择题。先靠近，再用作品确认你的兴趣。</p>
      </div>

      <div class="career-portal" data-reveal>
        <div class="career-portal__scene" data-pointer-depth="tilt" aria-hidden="true">
          <div class="portal-rings"><i /><i /><i /><i /></div>
          <div class="portal-gate">
            <span>{{ activePath.english }}</span>
            <strong>{{ activePath.signal }}</strong>
          </div>
          <div class="portal-lines">
            <i v-for="index in 16" :key="index" :style="{ '--index': index }" />
          </div>
        </div>

        <div class="career-portal__interface">
          <div class="career-choices" role="list" aria-label="职业方向">
            <button
              v-for="(path, index) in careerPaths"
              :key="path.id"
              type="button"
              :class="{ active: path.id === activeId }"
              :aria-pressed="path.id === activeId"
              @click="activeId = path.id"
            >
              <span>{{ String(index + 1).padStart(2, '0') }}</span>
              {{ path.name }}
            </button>
          </div>
          <article class="career-readout" aria-live="polite">
            <p>{{ activePath.english }} / ROUTE</p>
            <h3>{{ activePath.name }}</h3>
            <span>{{ activePath.description }}</span>
            <small>点击其他信号，观察传送门如何改变</small>
          </article>
        </div>
      </div>
    </div>
  </section>
</template>
